
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/basic-elements/typography",
      function () {
        return require("private-next-pages/basic-elements/typography.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/basic-elements/typography"])
      });
    }
  